import React, { useState, useEffect } from 'react';
import Chart from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { Row, Card, Col, CardBody, CardHeader } from 'reactstrap';
import {
  chartOptions,
  parseOptions,
  chartExample2
} from '../../../../../../variables/charts';

const CallCenterCallGraphics = ({ dataGraphics, dateBegin, dateEnd }) => {
  const [barChartData, setBarChartData] = useState(null);

  /**
   * @description: Formats data for the **received calls chart**
   * @param {Array} data - Array of objects with received calls data
   * @param {string} dateBegin - Start date in `dd/mm/yyyy` format
   * @param {string} dateEnd - End date in `dd/mm/yyyy` format
   */

  useEffect(() => {
    if (window.Chart) parseOptions(Chart, chartOptions());

    /**
     * Splits the `dateBegin` and `dateEnd` strings ("DD/MM/YYYY") into ["DD", "MM", "YYYY"]
     * Checks if the year and month are the same (returns boolean)
     */
    const [bDay, bMonth, bYear] = dateBegin.split('/').map(Number);
    const [eDay, eMonth, eYear] = dateEnd.split('/').map(Number);
    const sameYear = bYear === eYear;
    const sameMonth = sameYear && bMonth === eMonth;

    if (dataGraphics && dataGraphics.length > 0) {
      const arrayLabels = [];
      const arrayData = [];
      const colorsData = [];

      dataGraphics.forEach((item) => {
        const [day, month, year] = item.dateFormatted.split('/');

        /**
         * @description: Formats the date for the label
         */
        let labelDate;
        if (sameMonth) {
          labelDate = day;
        } else if (sameYear) {
          labelDate = `${day}/${month}`;
        } else {
          labelDate = `${day}/${month}/${year.slice(-2)}`;
        }

        /**
         * @description: Inserts value and color for answered calls
         * @description: Inserts value and color for abandoned calls
         */
        arrayLabels.push(`Dia ${labelDate}`);
        arrayData.push(item.answered ?? 0);
        colorsData.push('#00A07C');

        arrayLabels.push(`Dia ${labelDate}`);
        arrayData.push(item.abandoned ?? 0);
        colorsData.push('#d9534f');
      });

      setBarChartData({
        /**
         * @description: Labels for the x-axis
         * @type {Array}
         * @example ['Dia 01/01', 'Dia 02/01', ...]
         * @description: Labels for the y-axis
         * @type {Array}
         * @example [1, 2, 3, ...]
         */

        labels: arrayLabels,
        datasets: [
          {
            data: arrayData,
            maxBarThickness: 50,
            backgroundColor: colorsData
          }
        ]
      });
    }
  }, [dataGraphics, dateBegin, dateEnd]);

  return (
    <Card>
      <CardHeader className="introduct">
        <h5 className="h3 mb-0">
          Chamadas Recebidas Callcenter de {dateBegin} a {dateEnd}
        </h5>
      </CardHeader>
      <CardBody>
        <Row>
          <Col>
            {/*  Rótulo Chamadas Atendidas */}
            <div style={{ display: 'flex', gap: '20px', marginBottom: '15px' }}>
              <div
                style={{
                  backgroundColor: '#00A07C',
                  color: 'white',
                  fontWeight: '600',
                  padding: '8px 12px',
                  borderRadius: '4px'
                }}
              >
                Atendidas
              </div>
              {/*  Rótulo Chamadas Abandonadas */}
              <div
                style={{
                  backgroundColor: '#d9534f',
                  color: 'white',
                  fontWeight: '600',
                  padding: '8px 12px',
                  borderRadius: '4px'
                }}
              >
                Abandonadas
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <div className="chart">
              <Bar
                data={barChartData}
                options={chartExample2.options}
                className="chart-canvas"
                id="chart-bars"
              />
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default CallCenterCallGraphics;
